export default __webpack_public_path__ + "static/media/33.150f2371.png";